import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { RoleDomainModel, TipoComissaoEnum, UserModel, VinculoModel } from '@shared/models/backend'
import { getRole } from '@shared/utils/degts-utils'
import { take, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class UserContextService {
  private user: UserModel
  private initialized: boolean
  constructor(private http: HttpClient, private router: Router) {}

  get isInitialized() {
    return this.initialized
  }

  get userInfo() {
    return { ...this.user }
  }

  get vinculoAtual() {
    return this.user?.vinculoAtual
  }

  get residenteUser() {
    return this.user?.residenteUser
  }

  init() {
    return async () => {
      this.initialized = false
      try {
        await this.refresh().toPromise()
      } catch (err) {
        // no problem...probably not logged
      }
      this.initialized = true
    }
  }

  get isLogged() {
    return this.user?.id != null
  }

  get isCoreme() {
    return this.vinculoAtual?.comissao?.tipoComissao?.id === TipoComissaoEnum.COREME
  }

  get isSupervisorCoreme() {
    return !!this.vinculoAtual?.programa?.hashPrograma
  }

  hasRole(role: RoleDomainModel) {
    if (!this.isLogged) {
      return false
    }
    const roles = this.userRoles()
    for (let i = roles.length; i--; ) {
      if (roles[i].name === role.descricao) {
        return true
      }
    }
    return false
  }

  hasAnyRole(roles: RoleDomainModel[]) {
    for (const role of roles) {
      if (this.hasRole(role)) {
        return true
      }
    }
    return false
  }

  isSupervisor() {
    return this.hasRole(getRole('ROLE_SUPERVISOR'))
  }

  isCoordenador() {
    return this.hasRole(getRole('ROLE_COORDENADOR'))
  }

  isTransferencia() {
    return this.hasRole(getRole('ROLE_TRANSFERENCIA'))
  }

  isResidente() {
    return this.hasRole(getRole('ROLE_RESIDENTE'))
  }

  isDegts() {
    return this.hasRole(getRole('ROLE_DEGTS'))
  }

  isAdministrador() {
    return this.hasRole(getRole('ROLE_ADMINISTRADOR')) || this.hasRole(getRole('ROLE_DEGTS'))
  }

  isDev() {
    return this.hasRole(getRole('ROLE_DEV'))
  }

  destroy() {
    this.http
      .post('/api/unauthorize', {})
      .pipe(take(1))
      .subscribe((_) => {
        this.user = null
        this.router.navigateByUrl('/login')
      })
  }

  chooseVinculo(vinculo: VinculoModel) {
    this.user = null
    return this.http.put<UserModel>('/api/authorization/current/vinculo', vinculo).pipe(
      tap((user) => (this.user = user)),
      take(1)
    )
  }

  refresh() {
    this.user = null
    return this.http.get<UserModel>('/api/authorization/current').pipe(
      tap((user) => (this.user = user)),
      take(1)
    )
  }

  refreshAndDetectUserChanges() {
    const oldUserId = this.user?.id
    this.refresh().subscribe((user) => {
      if (oldUserId !== this.user?.id) {
        this.router.navigateByUrl('/login')
      }
    })
  }

  private userRoles() {
    return this.vinculoAtual ? [this.vinculoAtual.role] : this.user?.roles
  }
}
